//import { NavDropdown, Nav } from "react-bootstrap";

const MainMenu = () => {
    
    return (   
        <ul>
            {/* <li><a href="/" >Home</a><div className="link-underline"></div></li> */}
            {/* <li><a href={`/voucher`} >Voucher</a><div className="link-underline"></div></li> */}
            {/* <li>
                <NavDropdown title="Ricerche" id="nav-dropdown">
                    <NavDropdown.ItemText>
                        <Link href={`${useRouter().basePath}/radar`} locale={useRouter().locale}>Ricerca</Link>
                    </NavDropdown.ItemText>
                    <NavDropdown.ItemText>
                        <Link href={`${useRouter().basePath}/radar/savedSearches`} locale={useRouter().locale}>Ricerche salvate</Link>
                    </NavDropdown.ItemText>
                </NavDropdown>
                <div className="link-underline"></div>
            </li> */}
        </ul>
    );
}

export default MainMenu